// About.jsx

import React from "react";
import "./About.css";
import Features from './Features';
import Footer from './Footer';
import ContactSection from './ContactSection';
import CertificationCertificate from './CertificationCertificate';
import { Link } from "react-router-dom";

import img1 from "./images/img1.png";





export default function About() {
  return (

    <div className="about-page">
      <div className="about-hero">
        <div className="about-overlay">
          <h1>אודות</h1>
        </div>

<div>
        
</div>


</div>
    <div className="page4">
 <div className="breadcrumb4">
  <Link to="/">בית</Link> /{" "}
  <Link to="/About">  אודות </Link>
</div>
</div>

  <Features/>




<div>


        <div className="about-images">
  {/* צד תמונות */}                     
           <img src={img1} alt="" />

     <div>
                 <div className="text1" >
           <h2>  קבלן ויועץ לשיקום מבנים עבודות איטום וסנפלינג!</h2>
          <h2>   איטומים בגבהים יועצים וקבלנים לכל עבודות האיטום והסנפלינג</h2>

         <p style={{ color: "white" }}>
           חברת איטומים בגבהים הוקמה ע"י מקסים סרור לפני למעלה מעשור לאחר שצבר ניסיון וידע רב ע"י עבודה רבת שנים בתחום האיטום והסנפלינג.
          </p>

       <p style={{ color: "white" }}>
           אנו באיטומים בגבהים מתמחים בכל עבודות האיטום והסנפלינג אנו מספקים את שרותינו לכלל הציבור, בין לקוחותינו נמצאים לקוחות המגזר הפרטי,ועדי בניין, קבלני בניין, חב' ניהול, קבלני שיפוצים ועוד....
אנו שמים את מלוא תשומת הלב והדגש על מתן השירות ללקוחותינו וביצוע העבודה לשביעות רצונם. את כל זה אנו מבצעים ע"י צוותי עובדים בעלי ידע וניסיון רב בכל רזי התחום של עבודות האיטום והסנפלינג  ללא פשרות על איכות החומרים מקצועיות העובדים והכשרתם.
          </p>
<p style={{ color: "white" }}>
נשמח לעמוד לרשותכם ולתת גם לכם שירות אדיב, אישי ואמין תוך עמידה בסטנדרטים הגבוהים ביותר.
תודה שגם את/ה בוחר/ת באיטומים בגבהים.          </p>

     


        </div>
          </div>

        </div>

        {/* צד טקסט */}
   





</div>






  <CertificationCertificate/>

  <ContactSection/>


      </div>
  );
}


